import React from 'react';
import { Container, Typography, Box, IconButton, Paper, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PaymentIcon from '@mui/icons-material/Payment';
import ConstructionIcon from '@mui/icons-material/Construction';

const AdminPayments: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 5 }}>
      <Box className="page-header">
        <Box className="title-row" sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton onClick={() => navigate('/admin')} aria-label="back to admin">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" component="h1" className="page-title">Payments</Typography>
        </Box>
      </Box>

      <Alert severity="info" sx={{ mb: 3 }}>
        This feature is under development.
      </Alert>

      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, mb: 3 }}>
          <PaymentIcon sx={{ fontSize: 48, color: 'primary.main' }} />
          <ConstructionIcon sx={{ fontSize: 32, color: 'warning.main' }} />
        </Box>
        <Typography variant="h6" gutterBottom>
          Payment Management Coming Soon
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          The Payment Center will allow you to manage:
        </Typography>
        <Box component="ul" sx={{ textAlign: 'left', maxWidth: 400, mx: 'auto', color: 'text.secondary' }}>
          <li>User subscriptions</li>
          <li>Payment history</li>
          <li>Refund processing</li>
          <li>Billing information updates</li>
          <li>Invoice generation</li>
          <li>Payment method management</li>
        </Box>
      </Paper>
    </Container>
  );
};

export default AdminPayments;
